import React from "react";
import '../css/terms.scss'

const Terms = ({ handleClose2 }) => {
  return (
    <div className="terms">
      <button onClick={handleClose2}>Volver</button>
      <h1>REGLAMENTO DEL JUEGO LOTTOQÜIZ</h1>
      <h2>CAPÍTULO I DISPOSICIONES GENERALES</h2>
      <div className="article">
        <h5 className="title">Objeto del Reglamento</h5>
        <p>
          <span>ARTÍCULO 1.</span> El presente Reglamento tiene por objeto
          establecer las bases, normas y condiciones que rigen el Juego de
          lotería denominado <span>“LOTTOQÜIZ”,</span> propiedad y operado por
          la Sociedad Mercantil <span>THE BROTHERS PLAY C.A.,</span> en lo
          sucesivo “LA OPERADORA” y autorizado por el Instituto Oficial de
          Beneficencia Pública y Asistencia Social Servicio Desconcentrado
          Lotería de Caracas, en lo sucesivo “LA LOTERÍA”.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Denominación del Juego de Lotería</h5>
        <p>
          <span>ARTÍCULO 2.</span> El nombre o denominación del juego aquí
          reglamentado es: <span>“LOTTOQÜIZ”.</span>
        </p>
      </div>
      <div className="article">
        <h5 className="title">Definiciones</h5>
        <p>
          <span>ARTÍCULO 3.</span> A los efectos del presente Reglamento se
          entenderá por:{" "}
        </p>
        <ol type="a">
          <li>
            {" "}
            <span>APOSTADOR: </span>Persona que paga el derecho a participar en
            el juego de lotería, ofreciéndosele a cambio un premio en dinero y/o
            especie, el cual ganará solo si acierta los resultados del juego.{" "}
          </li>
          <li>
            {" "}
            <span>APUESTA: </span>Adquisición de ticket o cartón del juego
            autorizado <span>LOTTOQÜIZ</span> que contiene la combinación de
            números con los cuales participa el apostador en el sorteo para el
            cual fue adquirido.
          </li>
          <li>
            <span>CÓDIGO DE SEGURIDAD: </span>El código alfanumérico, único e
            irrepetible, que identifica y certifica que la apuesta pretendida
            por el apostador o jugador ha sido autorizada y registrada por LA
            OPERADORA, lo que le confiere valor legal.
          </li>
          <li>
            {" "}
            <span>MEDIO DE APUESTA: </span>Está constituido por los tickets o
            cartones, mediante los cuales se materializa la apuesta del juego,
            el cual debe cumplir con las normas establecidas en el presente
            Reglamento y en las normas aplicables.
          </li>
          <li>
            {" "}
            <span>SORTEO ORDINARIO: </span>Es aquel evento del Juego{" "}
            <span>LOTTOQÜIZ</span> que se realiza semanal, quincenal o mensual,
            según lo establezca la Empresa Operadora. El valor del cartón de
            juego y el monto de la premiación son establecidos por la Empresa
            Operadora.{" "}
          </li>
          <li>
            {" "}
            <span>SORTEO EXTRAORDINARIO: </span>Es aquel evento del Juego{" "}
            <span>LOTTOQÜIZ</span> en el que el valor del cartón de Juego sea
            superior al sorteo ordinario, los cuales serán establecidos por la
            Empresa Operadora. Este Sorteo será alusivo a una celebración o
            conmemoración, o evento que establezca LA OPERADORA como
            extraordinario.
          </li>
          <li>
            {" "}
            <span>SORTEO ESPECIAL: </span>Es aquel evento del Juego{" "}
            <span>LOTTOQÜIZ</span> en el que la Empresa Operadora ofrezca
            premios no regulares en los seriales tales como: Vehículos,
            Motocicletas u otros bienes.
          </li>
        </ol>
      </div>
      <h2>CAPÍTULO II DEL JUEGO</h2>
      <div className="article">
        <h5 className="title">Estructura del Juego de Lotería LottoQüiz </h5>
        <p>
          <span>ARTÍCULO 4.</span> El <span>"LOTTOQÜIZ"</span> es un juego de
          lotería tipo loto, preimpreso y/o digital. Este juego consiste en la
          extracción individual, desde una Máquina de Sorteo, sin reposición, de
          una cantidad, que la Empresa Operadora{" "}
          <span>THE BROTHERS PLAY C.A.</span> predeterminará, de bolitas de
          entre una serie de números continuos y ascendentes, numeradas en forma
          correlativa del número cero uno (01) al número más alto de la serie
          total, ambos inclusive, las que se habrán introducido previamente en
          la citada Máquina de Sorteo.
        </p>
        <p>
          <span>PARÁGRAFO ÚNICO.</span> Durante un primer período la extracción
          será de nueve (9) bolitas de un conjunto total de veinticinco (25)
          bolitas, numeradas del uno (01) al veinticinco (25). Esta cantidad
          podrá ser aumentada o disminuida por la Empresa Operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> cuando lo crea conveniente. Se le
          participará al Instituto Oficial de Beneficencia Pública y Asistencia
          Social Servicio Desconcentrado Lotería de Caracas.{" "}
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 5.</span> Los apostadores participan en este juego
          mediante la adquisición de los instrumentos de juego o medios de
          apuesta, denominados <span>"Cartones o tickets" </span>de{" "}
          <span>LOTTOQÜIZ</span>, los que entre otras informaciones, llevarán
          impreso una combinación de nueve (9) números que van del 01 al 25 y
          que corresponde a la numeración de las bolitas introducidas en la
          Máquina de Sorteo.{" "}
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 6.</span> Queda entendido y convenido expresamente que
          el juego <span>LOTTOQÜIZ</span>, consta de un sólo elemento o
          instrumento de juego, y que desde el momento en que el apostador lo
          haya comprado, queda bajo su única y exclusiva responsabilidad, tanto
          el cartón del juego <span>LOTTOQÜIZ</span> como lo que en él se
          materialice; dado que este juego consta de un solo elemento o
          instrumento de juego, y que al producirse la apuesta queda en manos
          exclusivamente del comprador-apostador que se entiende el portador.{" "}
        </p>
      </div>
      <div className="article">
        <h5 className="title">
          Características del cartón o ticket del juego LottoQüiz
        </h5>
        <p>
          <span>ARTÍCULO 7.</span> Los cartones o tickets del juego{" "}
          <span>LOTTOQÜIZ</span>, tendrán en las siguientes características:{" "}
        </p>
        <ol>
          <p className="list">EN EL ANVERSO:</p>
          <li>
            El Logotipo del juego <span>"LOTTOQÜIZ."</span>
          </li>
          <li>Logotipo de la Lotería Oficial. </li>
          <li>El número del sorteo. </li>
          <li>Fecha, día y hora del sorteo respectivo. </li>
          <li>Número de serial único por cartón. </li>
          <li>Código (s) de seguridad para validación del cartón.</li>
          <li>El precio del Cartón o ticket. </li>
        </ol>
        <ol>
          <p className="list">EN EL REVERSO:</p>
          <li>
            Un extracto del Reglamento del Juego <span>"LOTTOQÜIZ."</span>
          </li>
          <li>Datos de identificación del portador del cartón. </li>
          <li>
            Probabilidad de ganar y demás requisitos establecidos en la Ley
            Nacional de Loterías.
          </li>
        </ol>
      </div>
      <div className="article">
        <h5 className="title">Otros sistemas de seguridad </h5>
        <p>
          <span>ARTÍCULO 8.</span> La empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> podrá determinar otros sistemas
          de seguridad que se podrán agregar al cartón, para aumentar su
          seguridad, estos cambios serán debidamente participados a LA LOTERÍA.{" "}
        </p>
      </div>
      <div className="article">
        <h5 className="title">Emisión de los cartones o tickets </h5>
        <p>
          <span>ARTÍCULO 9.</span> La empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> queda ampliamente facultada, para
          ordenar la emisión, total o parcial, de la cantidad de cartones que
          estime conveniente, según el comportamiento del mercado, en cada uno
          de los respectivos sorteos. Esto se realizará de manera aleatoria
          determinado por el software propiedad de la empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.</span>
        </p>
      </div>
      <div className="article">
        <h5 className="title">Validez del Cartón o Ticket </h5>
        <p>
          <span>ARTÍCULO 10.</span> La empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> no reconocerá como válido ningún
          cartón que no haya sido emitido o impreso por ella, o por la empresa
          debidamente autorizada, para efectuar la emisión o impresión de los
          cartones del juego <span>LOTTOQÜIZ,</span> o que no haya sido vendido
          de forma digital por los medios autorizados por la OPERADORA. La
          OPERADORA no reconocerá como válido ningún cartón que no cumpla con
          los requisitos y elementos de seguridad establecidos.{" "}
        </p>
      </div>
      <div className="article">
        <h5 className="title">Valor del Cartón o Ticket </h5>
        <p>
          <span>ARTÍCULO 11.</span> El monto o valor de la apuesta o ticket del
          juego <span>LOTTOQÜIZ,</span> que adquiera el apostador jugador será
          el indicado en el mismo ticket o apuesta realizada, según el tipo de
          sorteo para el cual se adquiera.{" "}
        </p>
      </div>
      <h2>CAPÍTULO III DE LA CATEGORÍA DE GANADORES Y/O PREMIOS </h2>
      <div className="article">
        <h5 className="title">Categoría de ganadores </h5>
        <p>
          <span>ARTÍCULO 12.</span> Existirán, inicialmente, cuatro (4)
          Categorías de ganadores, las cuales se denominarán así:{" "}
        </p>
        <ol>
          <li>
            Primera Categoría de ganador o ganadores de nueve (9) aciertos.
          </li>
          <li>Segunda Categoría o ganadores de ocho (8) aciertos. </li>
          <li>Tercera Categoría o ganadores de siete (7) aciertos. </li>
          <li>Cuarta Categoría o ganadores de los premios especiales. </li>
        </ol>
      </div>
      <div className="article">
        <h5 className="title">Formas de ganar</h5>
        <p>
          <span>ARTÍCULO 13.</span> Las formas de ganar de acuerdo a las
          categorías señaladas en el artículo anterior, son:{" "}
        </p>
        <ol>
          <li>
            Primera Categoría de ganador o ganadores de nueve (9) aciertos. Será
            el portador o los portadores del Cartón o de los Cartones, cuyo
            contenido coincida completamente, con todos aquellos números
            impresos en las bolitas extraídas de la Máquina de Sorteo, en el
            acto del sorteo, es decir, Ticket o Tickets con nueve (9) aciertos.{" "}
          </li>
          <li>
            Segunda Categoría o ganadores de ocho (8) aciertos. La Segunda
            Categoría de Ganadores, será el portador o los portadores de los
            Cartones cuyo contenido difiera sólo de un (1) número con los
            extraídos de la Máquina de Sorteo en el acto del Sorteo, es decir,
            Cartón o Cartones con ocho (8) aciertos.{" "}
          </li>
          <li>
            Tercera Categoría o ganadores de siete (7) aciertos. La Tercera
            Categoría de Ganadores, será el portador o los portadores de los
            Cartones cuyo contenido difiera solo en dos (2) números con los
            extraídos de la Máquina de Sorteo en el acto del Sorteo, es decir,
            Cartón o Cartones con siete (7) aciertos.{" "}
          </li>
          <li>
            <p>
              Cuarta Categoría o ganadores de los premios especiales, cuyo
              serial de identificación que tiene cada uno de los cartones del{" "}
              <span>LOTTOQÜIZ,</span> hayan resultado ganador de cualquiera de
              los premios secos que, previamente al sorteo donde resultó ganador
              se establezcan, los cuales se anunciará al público a través de los
              medios de comunicación, redes sociales y/o por cualquier vía que
              considere pertinente la Empresa Operadora.{" "}
            </p>
            <p>
              El serial de identificación, que tiene cada Cartón del{" "}
              <span>"LOTTOQÜIZ" </span>debe coincidir completamente con todos
              aquellos números impresos en las bolitas extraídas en el acto del
              respectivo Sorteo, es decir, cartones cuyo número de
              identificación coincidan con la totalidad de los números extraídos
              en igual forma de extracción. Queda claro que los premios
              especiales serán establecidos por la empresa operadora{" "}
              <span>THE BROTHERS PLAY C.A.,</span> y no estarán presentes en
              todos los sorteos, solo serán en los sorteos para los que se
              anuncie. La forma de sorteo podrá ser modificada en cualquier
              momento por momento por LA OPERADORA, la cual comunicará
              previamente por los medios de comunicación, redes sociales y/o
              cualquier vía que considere pertinente. De las modificaciones se
              le participará a LA LOTERÍA, para su debido conocimiento.{" "}
            </p>
          </li>
        </ol>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 14.</span> Todos aquellos Cartones con seis (6) o menos
          aciertos, sólo tendrán la opción a concursar por los premios
          correspondientes a la Cuarta Categoría.{" "}
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 15.</span> El valor en dinero que corresponderá como
          premio a cada uno del cartón o cartones, Ganador o Ganadores de
          cualquiera de las Categorías, será el resultante de dividir el monto
          total en dinero asignado a esa Categoría entre la cantidad de Cartón o
          Cartones ganador o ganadores que hubieren resultado en esa misma
          Categoría; esto referente a las Tres Primeras Categorías de Premios,
          por cuanto, a la Cuarta Categoría de Premios corresponderá el premio
          en efectivo, en especie o en cualquier otra forma que fuere{" "}
          <span>PREFIJADO</span> por la Empresa Operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> para cada uno de los ganadores de
          ésta última Categoría en el respectivo sorteo.{" "}
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 16.</span> La empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> reconocerá como ganador o
          ganadores de Premios los que resulten de las combinaciones que
          resultaron de las bolitas extraídas, y que consten en forma fehaciente
          en sus registros o sistema.{" "}
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 17.</span> Sólo se pagarán premios al Cartón o Cartones
          que resulten ganadores y que consten en los archivos o sistema de la
          empresa operadora <span>THE BROTHERS PLAY C.A.</span> A cada Cartón
          ganador corresponderá un sólo premio, es decir, aquel al cual se ha
          hecho acreedor de acuerdo al máximo número de aciertos; esto con
          respecto a los ganadores de las Tres (3) Primeras Categorías, ya que,
          los que acierten los Premios de la Cuarta (4) Categoría o Premios
          Especiales, en el caso de que resulten ganadores de cualquiera otra
          Categoría cobrarán el otro Premio a que tiene derecho; asimismo, en
          caso de que el mismo cartón salga favorecido con otro u otros premios
          de la Cuarta (4) categoría los cobrarán en su totalidad.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Cambio de categorías </h5>
        <p>
          <span>ARTÍCULO 18.</span> LA OPERADORA podrá cambiar las Categorías de
          premios aumentándolas o disminuyéndolas, según el comportamiento del
          mercado. Se le participará al Instituto Oficial de Beneficencia
          Pública y Asistencia Social Servicio Desconcentrado Lotería de
          Caracas, para su conocimiento.{" "}
        </p>
      </div>
      <div className="article">
        <h5 className="title">Números coincidentes </h5>
        <p>
          <span>ARTÍCULO 19.</span> Para efectos de la determinación de la
          cantidad de números coincidentes entre los que incluyen los cartones y
          los números extraídos en el acto del Sorteo, no importará el orden en
          que estos últimos fueron extraídos, sino en el conjunto total de
          ellos; esto referente a las Tres Primeras Categorías de Premios, por
          cuanto, en la Cuarta Categoría de Premios deben coincidir, el número y
          el orden de extracción.{" "}
        </p>
      </div>
      <div className="article">
        <h5 className="title">Excepción de pago </h5>
        <p>
          <span>ARTÍCULO 20.</span> No se pagarán aquellos premios cuyo valor,
          resultante del cálculo indicado anteriormente, sea inferior al precio
          del cartón o ticket, en el respectivo Sorteo.{" "}
        </p>
      </div>
      <h2>CAPÍTULO IV RECAUDACIÓN Y EL ACUMULADO </h2>
      <div className="article">
        <h5 className="title">Recaudación</h5>
        <p>
          <span>ARTÍCULO 21.</span> El total de cartones vendidos multiplicado
          por el precio de venta, producirá lo que se denominará "RECAUDACIÓN
          TOTAL".{" "}
        </p>
      </div>
      <div className="article">
        <p>
          <span>
            ARTÍCULO 22. DE LOS SORTEOS. De los Ordinarios o Extraordinarios:
          </span>{" "}
          En caso de no existir ganador o ganadores de la Primera Categoría (9
          aciertos), en los sorteos ordinarios o extraordinarios, es decir, de
          no existir Cartón o Cartones ganadores con nueve aciertos, la Empresa
          Operadora <span>THE BROTHERS PLAY C.A.,</span> queda ampliamente
          autorizada para determinar a qué sorteo o sorteos se le asignará el
          monto acumulado, pudiéndolo hacer de la siguiente forma:
        </p>
        <ol type="a">
          <li>
            En caso de no existir ganador o ganadores de la Primera Categoría en
            cualquier sorteo Ordinario u Extraordinario puede acumularse el
            monto para ser asignado al Premio de la misma Categoría de cualquier
            sorteo Ordinario u extraordinario siguiente o sub- siguientes.
          </li>
          <li>
            Puede repartir el monto del premio acumulado total o parcialmente
            entre cualquiera de las diferentes categorías de premios que
            conforman el respectivo prospecto del sorteo siguiente o
            sub-siguiente.{" "}
          </li>
          <li>
            La Empresa Operadora <span>THE BROTHERS PLAY C.A.,</span> queda
            ampliamente facultada para decidir la forma en que se va a repartir
            el monto acumulado entre las diferentes categorías del respectivo
            prospecto.{" "}
          </li>
        </ol>
        <p>
          <span>De los Especiales:</span> en el caso de no existir ganador o
          ganadores de los nueve (9) aciertos, la empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> queda facultada, si así lo
          considera, para distribuir de la siguiente forma la cuantía del
          premio:{" "}
        </p>
        <ol type="a">
          <li>
            Hasta un 50% para las diferentes categorías de ganadores del mismo
            sorteo o del sorteo posterior.{" "}
          </li>
          <li>
            El restante será distribuido para la primera categoría del sorteo
            siguiente.{" "}
          </li>
        </ol>
        <div className="article">
          <h5 className="title">
            Porcentaje para distribuir en las diferentes categorías{" "}
          </h5>
          <p>
            <span>ARTÍCULO 23.</span> La empresa operadora{" "}
            <span>THE BROTHERS PLAY C.A.,</span> queda ampliamente facultada
            para determinar qué tipo de sistema se va implantar para el cálculo
            de la distribución de los premios en el respectivo prospecto del
            juego <span>LOTTOQÜIZ:</span>{" "}
          </p>
          <ol type="a">
            <li>El sistema para-mutual;</li>
            <li>Prefijando el monto de los premios;</li>
            <li>Una combinación de los mismos.</li>
          </ol>
          <p>
            De la recaudación total obtenida en cada sorteo por concepto de
            ventas de cartones del juego <span>LOTTOQÜIZ,</span> se descontarán
            los gastos de distribución y publicidad, una vez efectuado dichos
            descuentos, a este monto se le denominará{" "}
            <span>RECAUDACIÓN NETA</span> y se destinará para pago de los
            premios, el treinta y tres por ciento (33 %). En forma provisional
            se establecen las siguientes categorías de premios y los montos del
            porcentaje a distribuir en ellas:{" "}
          </p>
          <ol>
            <li>
              Premio de Primera Categoría o Primer Premio (9 aciertos), el
              veinte por ciento (20%) del monto de la recaudación neta.{" "}
            </li>
            <li>
              Premio de Segunda Categoría o Segundo Premio (8 aciertos), el
              cuatro punto cinco por ciento (4.5 %) del monto de la recaudación
              neta.{" "}
            </li>
            <li>
              Premio de Tercera Categoría o Tercer Premio (7 aciertos), el cinco
              punto cinco por ciento (5.5 %) del monto de la recaudación neta.{" "}
            </li>
            <li>
              Premio de Cuarta Categoría o Premios especiales, el cual o los
              cuales serán fijados por la Empresa Operadora{" "}
              <span>THE BROTHERS PLAY C.A.,</span> el tres por ciento (3 %) del
              monto de la recaudación neta.{" "}
            </li>
          </ol>
          <div className="article">
            <h5 className="title">Cambio de porcentajes </h5>
            <p>
              <span>ARTÍCULO 24.</span> La empresa operadora{" "}
              <span>THE BROTHERS PLAY C.A.,</span> queda ampliamente facultada
              para, modificar parcial o totalmente los porcentajes anteriormente
              descritos en cualquier sorteo, así como el tipo de premio a pagar,
              en cada Categoría, bien sea en efectivo, en especie o en cualquier
              otra forma, cuando lo crea conveniente. Se le participará al
              Instituto Oficial de Beneficencia Pública y Asistencia Social
              Servicio Desconcentrado Lotería de Caracas.{" "}
            </p>
          </div>
          <div className="article">
            <h5 className="title">Determinación de los ganadores</h5>
            <p>
              <span>ARTÍCULO 25.</span> La determinación de los Cartones
              ganadores, dentro de cada Categoría, se efectuará mediante la
              comparación computacional con el Software propiedad de LA
              OPERADORA de las referencias de control y combinación de números
              de cada Cartón participante, con la serie de números extraídos en
              el acto del Sorteo.{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="article">
        <h5 className="title">Participación en el sorteo </h5>
        <p>
          <span>ARTÍCULO 26.</span> Solo participarán en el Sorteo respectivo, y
          optarán a un eventual Premio, de acuerdo a las pautas explicadas en
          las bases anteriores, aquellos cartones que fueran vendidos al público
          y como tales aparezcan registrados en los documentos de juego y
          archivos del sistema, correspondientes a esos Cartones de juego
          producidos por el Software, propiedad de la operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> previo a la realización del
          Sorteo.{" "}
        </p>
      </div>
      <h2>CAPÍTULO V COMERCIALIZACIÓN DE CARTONES </h2>
      <div className="article">
        <h5 className="title">
          Comercialización de cartón o ticket preimpreso{" "}
        </h5>
        <p>
          <span>ARTÍCULO 27.</span> El apostador deberá pagar en efectivo o a
          través de otro medio de pago, el monto del cartón o ticket a los
          distribuidores o vendedores autorizados, antes de que le sea
          entregado.{" "}
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 28.</span> Los comercializadores y vendedores de
          cartones son comerciantes independientes y asumen la total
          responsabilidad de las operaciones a su cargo. LA OPERADORA y LA
          LOTERÍA quedarán exentas de cualquier reclamación derivada de sus
          actuaciones.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Comercialización de cartón o ticket digital </h5>
        <p>
          <span>ARTÍCULO 29.</span> La comercialización de los tickets digitales
          del juego LOTTOQÜIZ, se realizará a través de la página web,
          aplicación móvil y cualquier medio digital o electrónico autorizado
          por LA OPERADORA.
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 30.</span> El apostador deberá registrarse en la Página
          Web o Aplicación Móvil o medio electrónico o digital autorizado por LA
          OPERADORA, suministrando sus nombres y apellidos, edad, cédula de
          identidad y correo electrónico.
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 31.</span> El apostador escogerá a través de las
          plataformas autorizadas por LA OPERADORA, el cartón o ticket digital y
          pagará el monto de la apuesta en línea.
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 32.</span> Las plataformas autorizadas por LA OPERADORA
          le proporcionarán al apostador el cartón o ticket Digital en su correo
          electrónico, con el cual participará en el sorteo correspondiente.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Prohibición </h5>
        <p>
          <span>ARTÍCULO 33.</span> So pena de nulidad, y por no tener capacidad
          negocial plena, los menores de dieciocho (18) años no podrán adquirir
          cartones del juego <span>LOTTOQÜIZ.</span> En consecuencia, tampoco
          podrán participar como apostadores, ni cobrar premios.
        </p>
      </div>
      <h2>CAPÍTULO VI DEL SORTEO </h2>
      <div className="article">
        <h5 className="title">Forma del Sorteo </h5>
        <p>
          <span>ARTÍCULO 34.</span> Los Sorteos se celebrarán en acto público,
          en la fecha, día y hora indicada en el cartón del respectivo sorteo y
          podrán ser transmitidos a través de medios de comunicación y/o
          plataformas digitales, al público en general; esto en lo que se
          refiere a las Tres Primeras Categorías de Premios y en cuanto a la
          Cuarta Categoría de Premios la empresa operadora THE BROTHERS PLAY
          C.A. escogerá el medio de comunicación y/o plataforma digital, la
          fecha, día, hora, así como el sistema para efectuar los respectivos
          sorteos de tales premios.
        </p>
        <p>
          <span>PARÁGRAFO PRIMERO.</span> La empresa operadora THE BROTHERS PLAY
          C.A. queda ampliamente facultada para cambiar el sistema de efectuar
          los sorteos, el día, fecha y la hora de los mismos, así como el medio
          de comunicación y/ o plataforma digital, cuando lo considere
          pertinente, previa participación oportuna al público y a LA LOTERÍA.
        </p>
        <p>
          <span>PARÁGRAFO SEGUNDO.</span> Los Sorteos serán presenciado por un
          funcionario competente quien levantará y firmará un acta del sorteo
          para dar fe pública de lo realizado y de sus resultados.
        </p>
        <p>
          <span>PARÁGRAFO TERCERO.</span> Los sorteos del juego se efectuarán de
          acuerdo a lo previsto en el Artículo 14 de la Ley Nacional de
          Loterías.
        </p>
        <p>
          <span>PARÁGRAFO CUARTO.</span> Los resultados de los sorteos serán
          informados al público a través de los medios de comunicación,
          plataformas digitales y/o redes sociales. En caso de surgir cualquier
          duda o controversia, el Instituto Oficial de Beneficencia Pública y
          Asistencia Social Servicio Desconcentrado Lotería de Caracas, la
          Operadora y los apostadores se someterán única y exclusivamente, para
          todos los efectos, a lo que se establezca en el vigente Reglamento del
          juego de lotería LOTTOQÜIZ y a lo que conste en el ACTA del sorteo
          respectivo.
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 35.</span> Si durante la extracción de las bolitas en
          el sorteo, para obtener los seriales ganadores de premios
          correspondientes a la Cuarta Categoría, se llegara a repetir una o
          varias veces, un serial, el mismo no se considera válido y, por ende,
          se volverá a sortear el premio en juego, a los fines de permitir un
          mayor número de cartones ganadores en esta categoría.
        </p>
      </div>
      <div className="article">
        <h5 className="title">La No Celebración de un Sorteo </h5>
        <p>
          <span>ARTÍCULO 36.</span> Si un Sorteo no se pudiere celebrar en la
          fecha prevista, su realización se pospondrá para la fecha, día y hora
          en que LA OPERADORA, lo crea conveniente, previa participación a LA
          LOTERÍA, así como al público a través de los medios de comunicación,
          plataformas y/ o redes sociales que considere pertinente.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Causas de suspensión del Juego </h5>
        <p>
          <span>ARTÍCULO 37.</span> Si cualquiera de los sorteos indicados en el
          presente Reglamento tuviere que ser suspendido por caso fortuito o
          fuerza mayor durante su ejecución, se levantará un Acta indicando las
          causas y los resultados obtenidos hasta el momento de la suspensión,
          si fuere el caso. El sorteo se realizará nuevamente o se reanudará,
          según el caso, en la fecha, día y hora que la empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.</span> lo estime conveniente, previa
          participación al público, a través de los medios de comunicación
          social, plataformas digitales o redes sociales. En caso de reanudación
          la ejecución del Sorteo continuará donde se había paralizado, es
          decir, las bolitas extraídas en el Sorteo interrumpido tendrán validez
          y se continuarán extrayendo las que falten para completar la cantidad
          de nueve bolitas, o la cantidad de bolitas requeridas para completar
          la combinación ganadora del respectivo Sorteo, de acuerdo con lo
          establecido en este Reglamento.
        </p>
      </div>
      <h2>CAPÍTULO VII DEL PREMIO </h2>
      <div className="article">
        <h5 className="title">Pago del premio </h5>
        <p>
          <span>ARTÍCULO 38.</span> El apostador o ganador legítimo, para hacer
          efectivo el cobro del premio, deberá cumplir con lo siguiente:
        </p>
        <ol>
          <li>Presentar el cartón original en buen estado de conservación.</li>
          <li>Fotocopia de la Cédula de Identidad o pasaporte. </li>
          <li>Ser mayor de edad.</li>
          <li>
            Debe aparecer claramente en el reverso del cartón sus nombres y
            apellidos, cédula o pasaporte, firma y huella dactilar.
          </li>
        </ol>
        <p>
          <span>PARÁGRAFO ÚNICO.</span> Sólo se pagarán a los Apostadores que
          presenten al cobro cartones premiados en condiciones que permiten la
          verificación de su autenticidad plena. Se considerarán nulos aquellos
          cartones que presenten: enmendaduras, tachaduras, adulteraciones,
          roturas, reconstrucciones o cualquier otro tipo de evidencia que
          impida la verificación de su autenticidad o que configuren intento de
          fraude. Tampoco serán válidos el cartón que no se encuentre en buen
          estado de conservación, y que su contenido y signos distintivos no
          estén completos. Asimismo, no serán válidos para cobrar premios,
          cualquier tipo de copia del cartón original o no, que haya sido
          denunciados de manera formal ante los organismos de seguridad del
          estado por hurto, robo, pérdida o por cualquier otra causa.
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 39.</span> La empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> se reserva el derecho de actuar
          judicialmente en caso de que se intentare cobrar premios con apuestas
          o cartones que se presuman hayan sufrido adulteraciones,
          falsificaciones o que hayan sido anulados en los casos de hurto, robo,
          pérdida o extravío de los mismos.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Plazo para el cobro del premio </h5>
        <p>
          <span>ARTÍCULO 40.</span> El apostador o ganador del cartón del juego{" "}
          <span>LOTTOQÜIZ</span> deberá cobrar el premio dentro de los quince
          (15) días continuos, contados a partir del día siguiente a la fecha de
          la realización del sorteo a que corresponda el Cartón ganador.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Premios no cobrados </h5>
        <p>
          <span>ARTÍCULO 41.</span> Los premios no reclamados por el apostador
          ganador en el plazo establecido en el presente Reglamento, serán
          dispuestos por la empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.</span>
        </p>
      </div>
      <div className="article">
        <h5 className="title">Prohibición de gestoría </h5>
        <p>
          <span>ARTÍCULO 42.</span> Queda terminantemente prohibido a los
          Distribuidores Autorizados y Vendedores autorizados del juego{" "}
          <span>LOTTOQÜIZ</span> servir de Gestores o intermediarios del Cobro
          de los Premios.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Retención del impuesto </h5>
        <p>
          <span>ARTÍCULO 43.</span> La Empresa Operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> queda ampliamente facultada para
          hacer la retención del respectivo Impuesto que establecen las Normas
          Tributarias y/o cualquier otro impuesto que corresponda por Ley, a las
          distintas categorías de premios.
        </p>
        <p>
          <span>PARÁGRAFO ÚNICO:</span> Además de los impuestos de Ley, quien
          resulte ganador de la Primera Categoría de Premios descritas en el
          presente Reglamento, de ser el caso, se descontará del monto del
          premio el uno por ciento (1%), que será repartido entre el
          Distribuidor de la Zona y el Punto de Venta donde fue comprado el
          cartón preimpreso. En caso de que la compra del cartón o ticket sea
          efectuada de manera digital a través de los medios de pago
          electrónicos permitidos por LA OPERADORA, el descuento estipulado no
          aplica.
        </p>
      </div>
      <div className="article">
        <p>
          <span>ARTÍCULO 44.</span> En ningún caso los premios del juego{" "}
          <span>LOTTOQÜIZ</span> generarán intereses ni estarán sujetos a
          corrección monetaria ni ajustes por inflación.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Derecho a la publicidad </h5>
        <p>
          <span>ARTÍCULO 45.</span> Todo ganador de un premio del juego{" "}
          <span>LOTTOQÜIZ,</span> para que pueda materializar el cobro del
          respectivo Premio, queda sujeto y obligado a la publicidad que le sea
          requerida por LA OPERADORA., sin que tal hecho le confiera derecho
          para exigir algún tipo de pago o compensación de alguna naturaleza,
          porque de lo contrario, el pago del premio permanecerá suspendido, sin
          perjuicio de que continue transcurriendo el termino de caducidad.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Caducidad de los Premios </h5>
        <p>
          <span>ARTÍCULO 46.</span> El derecho a cobrar los premios caducará a
          los quince (15) días continuos, contados a partir del día siguiente a
          la fecha de la realización del sorteo respectivo.
        </p>
        <p>
          Vencido el término de caducidad se extingue todo derecho a cobro o
          reclamo de Premio alguno.
        </p>
      </div>
      <h2>CAPÍTULO VIII DE LOS RECLAMOS </h2>
      <div className="article">
        <h5 className="title">Derecho a Reclamo </h5>
        <p>
          <span>ARTÍCULO 47.</span> El apostador o apostadores que se consideren
          con derecho a reclamo deberá hacerlo personalmente o por medio de
          apoderado, en las oficinas de la Operadora{" "}
          <span>THE BROTHERS PLAY C.A.,</span> la cual se encuentra en indicada
          en el reverso del cartón o ticket; o en cualquiera de las oficinas
          principales de los comercializadores en cada estado; y presentar los
          siguientes recaudos:
        </p>
        <ol>
          <li>
            Escrito de reclamo donde conste la identificación y domicilio del
            reclamante y su fundamento. Asimismo, dicho escrito debe estar
            debidamente firmado y estampada las huellas dactilares en el mismo.{" "}
          </li>
          <li>Fotocopia de la Cédula de Identidad o pasaporte. </li>
          <li>
            En caso de que el reclamante fuere apoderado del apostador deberá
            presentar poder debidamente autenticado y copia de la cédula de
            identidad.{" "}
          </li>
          <li>
            Cartón o ticket original objeto de reclamación en buen estado y en
            cumplimiento de lo señalado en el presente reglamento.{" "}
          </li>
        </ol>
        <p>
          <span>PARÁGRAFO PRIMERO.</span> Para que se admita la reclamación, el
          cartón deberá cumplir con los requisitos antes señalados; en caso
          contrario la empresa operadora <span>THE BROTHERS PLAY C.A.,</span> no
          le dará curso a la misma, ni admitirá la reclamación.
        </p>
        <p>
          <span>PARÁGRAFO SEGUNDO.</span> La empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A. y LA LOTERÍA</span> no asumirán
          responsabilidad alguna en caso de error en los datos registrados en el
          escrito de reclamación.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Lapso del Derecho a Reclamo </h5>
        <p>
          <span>ARTÍCULO 48.</span> El derecho a reclamo deberá ejercerse dentro
          del plazo máximo e improrrogable de quince (15) días continuos,
          contados a partir del día siguiente a la fecha del Sorteo
          correspondiente.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Domicilio Operadora </h5>
        <p>
          <span>ARTÍCULO 49.</span> En todo lo referente al juego{" "}
          <span>LOTTOQÜIZ</span> operado por la empresa{" "}
          <span>THE BROTHERS PLAY C.A.,</span> los interesados deberán dirigirse
          a la Avenida 19 abril, Quinta Alejandrina, Casa Nº A-87, Sector
          Pirineos, Municipio San Cristóbal, estado Táchira, República
          Bolivariana de Venezuela.
        </p>
      </div>
      <h2>CAPÍTULO IX DISPOSICIONES FINALES </h2>
      <div className="article">
        <h5 className="title">Responsabilidad ante Terceros </h5>
        <p>
          <span>ARTÍCULO 50.</span> La empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A. y LA LOTERÍA,</span> no asume obligación
          alguna por convenios efectuados por terceros, relacionados con el
          juego <span>LOTTOQÜIZ.</span>
        </p>
      </div>
      <div className="article">
        <h5 className="title">Cláusula de adhesión </h5>
        <p>
          <span>ARTÍCULO 51.</span> El hecho de participar en el Juego{" "}
          <span>LOTTOQÜIZ</span> implica, por parte del apostador, su aceptación
          y su adhesión a las bases, normas y condiciones previstas en el
          presente Reglamento del Juego <span>LOTTOQÜIZ.</span>
        </p>
      </div>
      <div className="article">
        <h5 className="title">Domicilio Especial </h5>
        <p>
          <span>ARTÍCULO 52.</span> Se establece como domicilio especial,
          exclusivo y excluyente la ciudad de San Cristóbal, Capital del estado
          Táchira, República Bolivariana de Venezuela, respecto de todas las
          acciones y asuntos judiciales o extrajudiciales, relacionados con este
          juego <span>LOTTOQÜIZ,</span> a la jurisdicción de cuyos Tribunales de
          justicia se someterán las partes pudiendo la empresa operadora{" "}
          <span>THE BROTHERS PLAY C.A.</span> acudir a otros Tribunales de
          Justicia y demás Organismos Públicos Regionales o Nacionales, cuando
          así lo estimare conveniente y fuere necesario.
        </p>
        <p>
          <span>PARÁGRAFO ÚNICO:</span> Los portadores y demás interesados en
          este juego renuncian a su domicilio natural, de conformidad con el
          Artículo 32 del Código Civil.
        </p>
      </div>
      <div className="article">
        <h5 className="title">Modificación del Reglamento </h5>
        <p>
          <span>ARTÍCULO 53.</span> LA OPERADORA podrá modificar o reformar
          estas bases, normas y condiciones, total o parcialmente, cuando lo
          consideren conveniente y fuere necesario y hará la correspondiente
          publicación a través de los medios de comunicación y/o plataformas
          digitales.
        </p>
      </div>
      <p className="sociecity">
        INSTITUTO OFICIAL DE BENEFICENCIA PÚBLICA SOCIEDAD MERCANTIL Y
        ASISTENCIA SOCIAL SERVICIO DESCONCENTRADO THE BROTHERS PLAY C.A. LOTERÍA
        DE CARACAS
      </p>
    </div>
  );
}

export default Terms